'use strict';
import React from 'react';
import { reduxForm } from 'redux-form';
import TextField from 'forms/textField';
import PlzCityInput from 'forms/plzCityInput';
import Checkbox from 'forms/checkbox';
import yup from 'yup';
import {merge} from 'lodash';
import {checkoutFields} from 'checkout/state';

@reduxForm({
    form: 'order_form',
    initialValues: {
            // // "shipping_country": "Deutschland",
            // // "billing_street": "Petersburger Str. 49",
            // // "phone": "01762438467",
            // // "billing_city_plz": "10249",
            // // "billing_last_name": "Müller",
            // "billing_country": "Deutschland",
            // // "billing_company": "Müller & Sohn",
            // // "billing_city_name": "Berlin",
            // // "email": "steffen@mllrsohn.com",
            // // "billing_first_name": "Steffen",
            // "billing_is_shipping": true

        billing_is_shipping: true,
        shipping_country: 'Deutschland',
        billing_country: 'Deutschland'
    },
    fields: Object.keys(checkoutFields),
    asyncValidate(data) {
        let validation = {
            email: yup.string().email('Ihre E-Mail Adresse scheint nicht korrekt zu sein').required('Bitte geben Sie eine E-Mail Adresse an'),
            phone: yup.string().required('Bitte geben Sie Ihre Telefonnummer an'),

            billing_first_name: yup.string().required('Bitte geben Sie Ihren Vornamen an'),
            billing_last_name: yup.string().required('Bitte geben Sie Ihre Nachnamen an'),
            billing_street: yup.string().required('Bitte geben Sie Ihre Straße an'),
            billing_city_name: yup.string().required('Bitte geben Sie Ihre Stadt an'),
            billing_city_plz: yup.string().required('Bitte geben Sie Ihre Postleitzahl an'),

            billing_is_shipping: yup.boolean().default(true),

            shipping_first_name: yup.mixed().when('billing_is_shipping', {is: false, then: yup.string().required('Bitte geben Sie Ihren Vornamen an')}),
            shipping_last_name: yup.mixed().when('billing_is_shipping', {is: false, then: yup.string().required('Bitte geben Sie Ihrem Nachnamen an')}),
            shipping_street: yup.mixed().when('billing_is_shipping', {is: false, then: yup.string().required('Bitte geben Sie Ihre Straße an')}),
            shipping_city_name: yup.mixed().when('billing_is_shipping', {is: false, then: yup.string().required('Bitte geben Sie Ihre Stadt an')}),
            shipping_city_plz: yup.mixed().when('billing_is_shipping', {is: false, then: yup.string().required('Bitte geben Sie Ihre Postleitzahl an')})
        };

        var schema = yup.object().shape(validation);
        return schema.validate(data, {abortEarly: false}).then(() => {
            return {};
        }).catch(err => {
            var allErrors = {};
            err.inner.forEach((validationError) => {
                allErrors[validationError.path] = validationError.message;
            });
            return Promise.reject(allErrors);
        });
    },
    getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
})
export default class CheckoutAddress extends React.Component {
    onSubmit(event) {
        event.preventDefault();
        this.props.handleSubmit(this.props.actions.handleSubmit)(event);

    }
    componentDidMount() {
        this.props.eventEmitter.on('submitForm', () => {
            this.props.handleSubmit(this.props.actions.handleSubmit)();
        });
    }
    renderShippingAddress(fields) {
        if (this.props.fields.billing_is_shipping && this.props.fields.billing_is_shipping.value === false) {
            return (
                <div className="shipping__wrapper">
                    <TextField field={fields.shipping_company} />
                    <div className="p5050">
                        <TextField field={fields.shipping_first_name} />
                        <TextField field={fields.shipping_last_name} />
                    </div>
                    <TextField field={fields.shipping_street} />
                    <PlzCityInput field={fields.shipping_city_plz} suggestType="postcode" />
                    <PlzCityInput field={fields.shipping_city_name} suggestType="city" />
                    <TextField disabled={true} field={fields.shipping_country} />
                </div>
            );
        } else {
            return <div className="steps__hint">Ihre Lieferadresse entspricht Ihrer Rechnungsadresse</div>;
        }
    }
    render() {
        var fields = {};
        Object.keys(this.props.fields).forEach(item => {
            fields[item] = merge(this.props.fields[item], checkoutFields[item]);
        });
        return (
            <div className="checkout__steps">
                <form ref="checkoutForm" onSubmit={::this.onSubmit}>
                    <div className="steps__contact">
                        <div className="steps__title">Ihre Kontaktdaten:</div>
                        <div className="p5050">
                            <TextField field={fields.email} />
                            <TextField field={fields.phone} />
                        </div>
                    </div>
                    <div className="steps__addresses">
                        <div className="steps__billing">
                            <div className="steps__title">Rechnungsadresse:</div>
                            <TextField field={fields.billing_company} />
                            <div className="p5050">
                                <TextField field={fields.billing_first_name} />
                                <TextField field={fields.billing_last_name} />
                            </div>
                            <TextField field={fields.billing_street} />
                            <PlzCityInput field={fields.billing_city_plz} suggestType="postcode" />
                            <PlzCityInput field={fields.billing_city_name} suggestType="city" />
                            <TextField disabled={true} field={fields.billing_country} />
                        </div>
                        <div className="steps__shipping">
                            <div className="steps__title">
                                Lieferadresse:
                                <div className="steps__billing--is-shipping">
                                    <Checkbox field={fields.billing_is_shipping} />
                                </div>
                            </div>
                            {this.renderShippingAddress(fields)}
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/steps/checkoutAddress.jsx